import angular from 'angular';

angular
  .module('cloudX')
  .controller('YesNoCancelDialogCtrl', [
    '$scope',
    '$element',
    'appMessages',
    'close',
    'title',
    'message',
    yesNoDialogCtrl,
  ]);

function yesNoDialogCtrl($scope, $element, appMessages, close, title, message) {
  $scope.title = appMessages(title);
  $scope.message = appMessages(message);
  $scope.close = function(result) {
    close(result, 500);
    //$element.modal('hide');
  };
  $scope.cancel = function() {
    //$element.modal('hide');
    close(null, 500);
  };
}
